module.exports = "../images/bear-hunting@2x.jpg?v=d0b5007";